import React from "react";
import { Col, Container, Row } from "shards-react";
import { getHistoricGraphData } from "../backend/BinAlgData";
import { parseDate } from "../backend/common";
import PageTitle from "../components/common/PageTitle";
import SmallStats from "../components/common/SmallStats2";

class PredictionGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lonja: "Binefar",
      user: this.props.user.user,
      date: null,
      data: {
        dates: [],
        dates_shift: [],
        animals: {
          real: [],
          predicted: [],
        },
        price: {
          real: [],
          predicted: [],
          binefar: [],
          ponderated_Real: [],
          ponderated_Predicted: [],
          algorithm: [],
          binefar_machos: [],
          binefar_hembras: [],
          predicted_machos: [],
          predicted_hembras: [],
        },
        kg: {
          real: [],
        },
        variation: {
          binefar: [],
          algorithm: [],
        },
        number: [],
      },
      type: "Machos281/320KG",
      activeUser: this.props.location.state?.activeUser
        ? this.props.location.state.activeUser
        : this.props.user.user,
    };
    this.getData = this.getData.bind(this);
    this.calculate_variation = this.calculate_variation.bind(this);
    this.to_fix_3 = this.to_fix_3.bind(this);
  }
  componentDidMount() {
    this.getData();
  }

  calculate_variation(oldValues, newValues) {
    const result = newValues.map((currVal, index) => {
      if (index === 0) {
        return;
      }

      const prevVal = oldValues[index - 1];
      return currVal - prevVal;
    });
    result.shift();
    return result;
  }
  calculate_variation_prediction(oldValues, newValues) {
    const result = newValues.map((currVal, index) => {
      if (index === 0) {
        return;
      }

      const prevVal = oldValues[index];
      return currVal - prevVal;
    });
    result.shift();
    return result;
  }

  getData() {
    getHistoricGraphData({ type: this.state.type }, (result) => {
      //console.log(result)
      const price_binefar = [];
      const price_algorithm = [];
      const dates = [];

      result["binefar"].forEach((value) => {
        dates.push(parseDate(value.date.standard));
        price_binefar.push(value["prices"]["U"]);
      });
      result["predicted"].forEach((value) => {
        price_algorithm.push(value.price);
      });

      const data = this.state.data;

      data.price.binefar = price_binefar;
      data.price.predicted = price_algorithm;
      data.dates = dates;
      data.dates_shift = JSON.parse(JSON.stringify(dates));
      data.dates_shift.shift();
      data.variation.binefar = this.calculate_variation(
        price_binefar,
        price_binefar
      );
      data.variation.algorithm = this.calculate_variation_prediction(
        price_binefar,
        price_algorithm
      );
      if (price_binefar[price_binefar.length - 1] == null)
        data.variation.binefar[data.variation.binefar.length - 1] = null;
      data.variation.algorithm[data.variation.binefar.length - 1] = null;
      this.setState({ data: data });
    });
  }

  to_fix_3(x) {
    if (x === null) {
      return null;
    }
    return Math.round(x * 1000) / 1000;
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4 pb-4">
        <div>
          <PageTitle
            title="Gráfica Predicción"
            subtitle={this.state.lonja}
            md="12"
            className="ml-sm-auto mr-sm-auto"
          />
          <Row>
            <Col sm="12" md="7">
              {/**
               */}
              <SmallStats
                id={`small-stats-0`}
                variation="2"
                chartData={{
                  labels: this.state.data.dates,
                  datasets: [
                    {
                      label: "Binefar",
                      fill: "start",
                      borderWidth: 1.5,
                      backgroundColor: "rgba(255,180,0,0.4)",
                      borderColor: "rgba(255,180,0)",
                      data: this.state.data.price.binefar,
                    },
                    {
                      label: "Prediccion algoritmo",
                      backgroundColor: "rgba(255,65,105,0.1)",
                      borderColor: "rgba(255,65,105,1)",
                      data: this.state.data.price.predicted,
                      fill: "start",
                    },
                  ],
                }}
                label={"Predicción Machos 281/320KG U ="}
              />
              <SmallStats
                id={`small-stats-0`}
                variation="2"
                chartData={{
                  labels: this.state.data.dates_shift,
                  datasets: [
                    {
                      label: "Binefar",
                      fill: "start",
                      borderWidth: 1.5,
                      backgroundColor: "rgba(255,180,0,0.4)",
                      borderColor: "rgba(255,180,0)",
                      data: this.state.data.variation.binefar.map(
                        this.to_fix_3
                      ),
                    },
                    {
                      label: "Prediccion algoritmo",
                      backgroundColor: "rgba(255,65,105,0.1)",
                      borderColor: "rgba(255,65,105,1)",
                      data: this.state.data.variation.algorithm.map(
                        this.to_fix_3
                      ),
                      fill: "start",
                    },
                  ],
                }}
                label={"Variación del precio"}
              />
            </Col>
          </Row>
        </div>
      </Container>
    );
  }
}
export default PredictionGraph;
